module.exports = __webpack_public_path__ + "static/img/134.d7a5342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/134.jpg
// module id = qJax
// module chunks = 0